import cx from 'classnames';
import { AnimationControls, motion } from 'motion/react';

import type { JSX } from 'react';

type TypographyProps = {
  children: React.ReactNode;
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h4-subheading1';
  weight?: 'normal' | 'semi-bold' | 'bold';
  animationDelay?: number;
  animate?: AnimationControls;
  className?: string;
  isAnimated?: boolean;
  hidden?: boolean;
};

export default function Heading({
  children,
  variant,
  className,
  weight,
  animationDelay = 0,
  animate,
  isAnimated = false,
  ...otherProps
}: TypographyProps): JSX.Element {
  const classes = cx('', {
    'text-tui-8xl leading-[105%] tracking-[-0.05em] md-tui:text-[50px] lg-tui:text-[58px] xl-tui:text-[64px]':
      variant === 'h1',
    'text-[30px] leading-[110%] tracking-[-0.05em] md-tui:text-[32px] lg-tui:text-tui-7xl lg-tui:leading-[105%] xl-tui:text-[40px]':
      variant === 'h2',
    'text-tui-3xl leading-[115%] tracking-[-0.05em] lg-tui:text-tui-4xl lg-tui:leading-[110%] xl-tui:text-[32px]':
      variant === 'h3',
    'text-tui-xl leading-[115%] tracking-[-0.05em] lg-tui:text-tui-2xl xl-tui:text-tui-3xl':
      variant === 'h4',
    'text-tui-lg leading-[115%] tracking-[-0.04em] md-tui:text-tui-xl md-tui:tracking-[-0.05em] lg-tui:text-tui-2xl xl-tui:text-tui-3xl':
      variant === 'h4-subheading1',

    'font-normal': weight === 'normal',
    'font-semibold': weight === 'semi-bold',
    'font-bold': weight === 'bold'
  });
  return isAnimated ? (
    <motion.h1
      className={`${classes} ${className} `}
      {...otherProps}
      variants={{
        hidden: { y: 60, opacity: 0 },
        visible: { y: 0, opacity: 1 }
      }}
      initial="hidden"
      animate={animate || 'visible'}
      transition={{
        duration: 1.4,
        delay: 0.2 + animationDelay,
        ease: 'easeOut'
      }}
    >
      {children}
    </motion.h1>
  ) : (
    <p className={`${classes} ${className} `} {...otherProps}>
      {children}
    </p>
  );
}
